<template>
    <el-container style="height: 100%">
        <el-header style="height: 50px;padding: 0px">
            <van-nav-bar title="PK金返还" left-text="返回" left-arrow @click-left="historyBackPath('intebotab')"/>
        </el-header>
        <el-main style="padding: 0px;height: 100%">
            <el-form :inline="true" :model="searchParms" size="mini">
                <el-form-item label="门店">
                    <el-cascader :options="storeData" filterable clearable v-model="searchParms.storeStructs" :props="{ checkStrictly: true }" size="mini" style="width: 100%" @change="storeChange"></el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-radio-group v-model="searchParms.finished" @change="storeChange">
                        <el-radio :label="-1">全部</el-radio>
                        <el-radio :label="0">未返还</el-radio>
                        <el-radio :label="1">已返还</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="openAdd()" size="mini">PK金登记</el-button>
                </el-form-item>
            </el-form>
            <el-table height="calc(100% - 3rem)" border :data="bonusData" size="mini" style="text-align: center" highlight-current-row>
                <el-table-column label="门店"  align="center" prop="storename">
                    <template slot-scope="scope">
                        {{scope.row.parentname}}/{{scope.row.storename}}
                    </template>
                </el-table-column>
                <el-table-column label="支付日期"  align="center" prop="paydate"></el-table-column>
                <el-table-column label="支付金额"  align="center" prop="bonusamount"></el-table-column>
                <el-table-column label="操作"  align="center">
                    <template slot-scope="scope">
                        <el-button @click="openBack(scope)" v-if="scope.row.finished==0" type="text" size="small" style="color: red">退还</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
        <el-dialog title="PK金返还" :visible.sync="dialogVisible" width="100%" top="0px" class="notpay" :close-on-click-modal="false">
            <el-form ref="form" :model="inteboBonus" label-width="140px" size="mini">
                <el-form-item label="门店" prop="sysbillid">
                    <span>{{inteboBonus.parentname}}/{{inteboBonus.storename}}</span>
                </el-form-item>
                <el-form-item label="支付日期" prop="paydate">
                    {{inteboBonus.paydate}}
                </el-form-item>
                <el-form-item label="支付金额" prop="bonusamount">
                    {{inteboBonus.bonusamount}}
                </el-form-item>
                <el-form-item label="返还日期" prop="backdate">
                    <el-date-picker value-format="yyyy-MM-dd" size="mini" style="width: 100%"
                                    v-model="inteboBonus.backdate"
                                    type="date"
                                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" :loading="queryLoadBtton" size="mini" @click="backBonusAmount()">保存</el-button>
            </div>
        </el-dialog>
        <el-dialog title="PK金登记" :visible.sync="dialogVisiblePk" width="100%" top="0px" class="notpay" :close-on-click-modal="false">
            <el-form ref="form" :model="addInteboBonus" size="mini" label-width="80px" :rules="rules" class="sale">
                <el-form-item label="单号" prop="sysbillid">
                    {{addInteboBonus.sysbillid}}
                </el-form-item>
                <el-form-item label="门店名称" prop="storeid">
                    <el-cascader :options="storeData" filterable clearable v-model="parentstoreid" size="mini" style="width: 100%" @change="addStoreChange"></el-cascader>
                </el-form-item>
                <el-form-item label="PK金额" prop="bonusamount">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="addInteboBonus.bonusamount">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="支付日期" prop="paydate">
                    <el-date-picker value-format="yyyy-MM-dd" size="mini" style="width: 100%" v-model="addInteboBonus.paydate" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisiblePk = false" size="mini">取 消</el-button>
                <el-button type="primary" :loading="queryLoadBtton" size="mini" @click="saveInteboBonus()">保存</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            rules:{
                storeid: [
                    {required: true, message: "请选择门店", trigger: 'blur'},
                ],
                bonusamount:[
                    {required: true, message: "请输入PK金额", trigger: 'blur'},
                ],
                paydate:[
                    {required: true, message: "请选择支付日期", trigger: 'blur'},
                ]
            },
            parentstoreid:"",
            addInteboBonus:{},
            intebobonusBean:{
                parentid:"",
                storeid:"",
                sysbillid:"",
                bonusamount:0,
                paydate:"",
                finished:"",
                backdate:"",
            },
            dialogVisiblePk:false,
            inteboBonus:{},
            queryLoadBtton:false,
            dialogVisible:false,
            bonusData:[],
            storeData:[],
            searchParms:{
                storeStructs:[],
                finished:0,
            }
        }
    },
    created() {
        this.getInteboStoreStructs();
        this.getNotBackBonus();
    },
    methods:{
        getSysBillId(){
            this.$post("product/getSysBillId").then(res=>{
                if(res.sucess){
                    this.addInteboBonus.sysbillid=res.object;
                }
                else{
                    this.$message({message: res.message, type: 'error'});
                }
            });
        },
        openAdd(){
            this.parentstoreid=[];
            this.dialogVisiblePk=true;
            this.addInteboBonus=this.$copy(this.intebobonusBean);
            this.getSysBillId();
        },
        addStoreChange(val){
            this.addInteboBonus.parentid="";
            this.addInteboBonus.storeid="";
            if(val[0]){
                this.addInteboBonus.parentid=val[0];
            }
            if(val[1]){
                this.addInteboBonus.storeid=val[1];
            }
        },
        saveInteboBonus(){
            this.queryLoadBtton=true;
            if(!this.addInteboBonus.parentid){
                this.queryLoadBtton=false;
                this.$message({message: "请输入品牌信息", type: 'error'});
                return;
            }
            if(!this.addInteboBonus.storeid){
                this.queryLoadBtton=false;
                this.$message({message: "请输入门店信息", type: 'error'});
                return;
            }
            if(this.addInteboBonus.bonusamount<1){
                this.queryLoadBtton=false;
                this.$message({message: "请输入PK金额", type: 'error'});
                return;
            }
            if(!this.addInteboBonus.paydate){
                this.queryLoadBtton=false;
                this.$message({message: "请输入支付日期", type: 'error'});
                return;
            }
            this.$postw("intebosale/saveInteboBonus",this.addInteboBonus).then(res=>{
                this.queryLoadBtton=false;
                if(res.sucess){
                    this.$message({message: "请输入门店信息", type: 'success'});
                    this.dialogVisiblePk=false;
                    this.getNotBackBonus();
                }
            });
        },
        storeChange(){
            this.getNotBackBonus();
        },
        backBonusAmount(){
            if(!this.inteboBonus.backdate){
                this.$message({message: "请选择返还日期", type: 'error'});
                return;
            }
            this.queryLoadBtton=true;
            this.$postw("intebosale/backBonusAmount",this.inteboBonus).then(res=>{
                this.queryLoadBtton=false;
                if(res.sucess){
                    this.$message({message: "返还成功", type: 'success'});
                    this.dialogVisible=false;
                    this.getNotBackBonus();
                }
            });
        },
        openBack(scope){
            this.inteboBonus=scope.row;
            this.dialogVisible=true;
            this.inteboBonus.backdate="";
        },
        getNotBackBonus(){
            let parentid="";
            let storeid="";
            if(this.searchParms.storeStructs[0]){
                parentid=this.searchParms.storeStructs[0];
            }
            else if(this.searchParms.storeStructs[1]){
                parentid=this.searchParms.storeStructs[0];
                storeid=this.searchParms.storeStructs[1];
            }
            this.$post("intebosale/getNotBackBonus",{parentid:parentid,storeid:storeid,finished:this.searchParms.finished}).then(res=>{
                if(res.sucess){
                    this.bonusData=res.object;
                }
            });
        },
        getInteboStoreStructs(){
            this.$post("inteboStore/getInteboStoreStructs").then(res=>{
                if(res.sucess){
                    this.storeData=res.object;
                }
            });
        }
    }
}
</script>
<style lang="scss" rel="stylesheet/scss">
    .sale .el-input-number .el-input__inner {
        text-align: left;
    }
</style>


// WEBPACK FOOTER //
// src/page/intebo/intebotab/notbackbonus.vue